// BANNER
export const TITLE = <div>Partner Sales enablement</div>;

// INSTRUCTIONS
export const GOALS = "Learn how to find and qualify leads, and research potential clients.";
export const HOW = "The training is free and self-paced.";
export const WHAT = "You can start this training without any pre-requisites.";
export const REQUIREMENTS = "There are no pre-requirements to this training. Every resource should take this training, independently of their role";

// BADGE
const SALES_COVER_1 = "Introduction to Dynatrace";
const SALES_COVER_2 = "Master the art of discovery";
const SALES_COVER_3 = "Discover latest sales plays";
const SALES_COVER_4 = "Identify partner opportunities";
export const SALES_COVERS: String[] = [SALES_COVER_1, SALES_COVER_2, SALES_COVER_3, SALES_COVER_4];


// ACHIEVEMENTS
export const ACHIEVEMENTS = <div >
                        ·&nbsp;&nbsp; Upon completion of this training, you'll be able to find and qualify new leads, and research
                        <br></br>
                        &nbsp;&nbsp;&nbsp;potential clients.
                        <br></br>
                        <br></br>
                        ·&nbsp;&nbsp; After completing a <a className="linkQuiz" target="_blank" href="https://university.dynatrace.com/ondemand/course/47726?content=content&section=47734&learningPath=22520">small quiz</a>, you will be awarded with the Dynatrace Partner Sales badge.
                    </div>;
// -- 


// FAQs
// export const TITLE_ONE = "Sales Prospecting Guide for Partners";
export const TITLE_TWO = "New report: Top Challenges Facing CIOs";
export const TITLE_THREE = "Gartner recognizes Dynatrace as a Leader in the 2022 Magic Quadrant for APM and Observability";
// export const TITLE_FOUR = "Dynatrace Sales Plays 2022";

// export const SUB_TITLE_ONE = "According to the Dynatrace Partner program, each Partner needs to have 2 Core Partner Training certifications (which can be done by sales, pre-sales or post-sales resources) and 2 Associate certifications (which are technical).";
export const SUB_TITLE_TWO = <div>Our latest <a href="https://www.dynatrace.com/news/press-release/2022-global-cio-report/">global study of 1303 CIOs</a> reveals the Challenges Organizations Face as Cloud Complexity Rises.</div>;
export const SUB_TITLE_THREE = <div>We’re delighted to be named a Leader in <a href="https://www.dynatrace.com/gartner-magic-quadrant-for-application-performance-monitoring-observability/">Gartner’s 2022 Magic Quadrant for APM and Observability</a>, 
    with the furthest overall position for Completeness of Vision. This marks the 12th consecutive time Dynatrace has been positioned 
    in the Leaders’ quadrant for its Completeness of Vision and Ability to Execute.
    <br></br>
    <br></br>
    Gartner also released its Critical Capabilities for APM and Observability report, where Dynatrace scored highest 
    in four out of six use cases: <a href="https://www.dynatrace.com/gartner-critical-capabilities-for-application-performance-monitoring-observability/">Gartner's 2022 Critical Capabilities for APM and Observability</a>.</div>;
// export const SUB_TITLE_FOUR = <div>Please find these documents in the Collateral in the "Partner Enablement Resources" section under the sub-section Sales Play.</div>;

// --



